import React from 'react';
import { Box, Chip } from '@mui/material';
import { ColumnImportData } from '../parse';

interface Props {
	importData: ColumnImportData['toAdd'];
}

const AddedColumns = (props: Props) => {
	return (
		<Box mt={2} ml={2.5}>
			{props.importData.map((data) => {
				return <Chip key={data.label} sx={{ m: 0.5 }} label={data.label} />;
			})}
		</Box>
	);
};

export default AddedColumns;
